<template>
    <div class="HomePartenaire">
      <Title>Nos Partenaires</Title>
      <Title type="small">Nous accompagnent</Title>
      <Spacer></Spacer>
      <Spacer></Spacer>
        <Partners :items="PARTNERS"
                :limit="4"
                :auto="true"
                type="partners"
            />
    </div>
</template>

<script>
import Partners from '../global/Partners.vue'
import {PARTNERS} from "../../constant/PARTNERS";

export default {
    name: "HomePartenaire",
    components: {
        Partners
    },
  data(){
      return {
        PARTNERS
      }
  }
}
</script>

<style scoped>
/* 
* Global 
*/
.HomePartenaire {
    text-align: center;
    padding: 100px 25px 50px 25px;
}
</style>